


















































































































































































































































































































































































































































































































































































































































































































































































































































 import Vue from 'vue';
 import Tab from "../../components/tab/tab.vue";
 import { VueEditor, Quill } from "vue2-editor";

  export default Vue.extend({
    components: {
      VueEditor,
      Tab
    },
    data: () => ({
      show: true,
      job_id : '',
      showData : false,
      dataLoading : false,
      shortList_candidate : []
    }),
    
    created(){
      localStorage.removeItem("JobId");
      this.job_id= this.$route.params.id;
      this.shortListStudent();    
    },

    methods: {
      async shortListStudent(){
        this.dataLoading=true;
        let token =  localStorage.getItem("jwt");
        localStorage.setItem("JobId",this.job_id);
        if (token) {
          const auth = {
            headers: {authorization: token} 
          }   
          let resp = await this.$http.get('/job/displayShortlistedStudents/'+this.job_id, auth)
          console.log("resp",resp);
          if (resp.status === 200 && resp.data.message === "List of shortlisted students") {
            if (resp.data.data.length>0) {
              this.showData = true;
              this.shortList_candidate = resp.data.data;
              for (let i = 0; i < this.shortList_candidate.length; i++) {
                for (let j = 0; j < this.shortList_candidate[i].subjectwise_details.length; j++) {
                  if (this.shortList_candidate[i].subjectwise_details[j].average_marks>70){
                    this.shortList_candidate[i].subjectwise_details[j].average_marks = 'Grade A'
                  }else if (this.shortList_candidate[i].subjectwise_details[j].average_marks>50){
                    this.shortList_candidate[i].subjectwise_details[j].average_marks = 'Grade B'
                  }else if (this.shortList_candidate[i].subjectwise_details[j].average_marks>=30){
                    this.shortList_candidate[i].subjectwise_details[j].average_marks = 'Grade C'
                  }else{
                    this.shortList_candidate[i].subjectwise_details[j].average_marks = 'Grade D'
                  }
                }
              }
            }
          }
        }
      },
      viewCandidate(sid){
        this.$router.push({ name: 'candidate_details', params: { id: sid, test: 4 } })
      },
    }
})
